__turbopack_context__.v({
  "body": "index-module-scss-module__C-WnOG__body",
  "buttonWrapper": "index-module-scss-module__C-WnOG__buttonWrapper",
  "marginBottom": "index-module-scss-module__C-WnOG__marginBottom",
});
